<template>
    <div class="dff__intro" ref="introComponent">
        <div class="dff__intro-dff"><img src="/ResourcePackages/BaldwinHardware/assets/dist/images/logos/lock-designer-pp.svg" alt="puzzle pieces" width="40" height="40" /><span>Door Fit Finder</span></div>
        <div class="dff__intro-image"><img src="https://images.baldwinhardware.com/is/image/Baldwin/Find%20the%20Right%20Solution?wid=360" alt="Door Fit Finder" /></div>
        <h2 class="dff__intro-heading">Need Help Finding the Right Solution?<br />We Are Here to Help!</h2>
        <div class="dff__intro-description">Answer a few simple questions and we'll make sure your options will fit your door.</div>
        <button @click="goToNextStep()" class="btn btn-outline-primary btn-lg">Get Started</button>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const introComponent = ref(null);

const goToNextStep = () => {
    store.commit('updateActiveComponent', 'questions');
};

onMounted(() => {
    setTimeout(() => {
        introComponent.value.classList.add('state-mounted');
    }, 500);
});

onBeforeUnmount(() => {
    introComponent.value.classList.remove('state-mounted');
    setTimeout(() => {
        //giving the css animation time to finish before mounting the next thing
    }, 500);
});
</script>
